module.exports = __webpack_public_path__ + "static/img/pd_top_3.dc3870d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerpic/footerDetailPic/pd_top_3.jpg
// module id = o6Tb
// module chunks = 51